/**
 * API Configuration
 * Centralized configuration for API communication
 */

export const API_CONFIG = {
  /** Base URL for API requests. Empty string means same-origin. */
  BASE_URL: import.meta.env.VITE_API_URL ?? '',
  /** Request timeout in milliseconds */
  TIMEOUT: 30000,
  /** Number of retry attempts for failed requests */
  RETRY_ATTEMPTS: 3,
  /** Delay between retry attempts in milliseconds */
  RETRY_DELAY: 1000,
} as const;

/** Header name for workspace ID */
export const WORKSPACE_HEADER = 'X-Workspace-Id';
